var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSally(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 483.82 603.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .eyes{display:none;}.cls-sally-1{fill:#f0ac7f;}.cls-sally-2{fill:#20344d;}.cls-sally-3{fill:#2e200c;}.cls-sally-4{fill:#736e5b;}.cls-sally-5{fill:#846436;}.cls-sally-6{clip-path:url(#clip-sally-path);}.cls-sally-7{fill:#e19e71;}.cls-sally-8{fill:none;stroke:#846436;stroke-miterlimit:10;stroke-width:0.91px;}.cls-sally-9{fill:#aa8553;}.cls-sally-10{fill:#fff;}.cls-sally-11{fill:#c35e50;}.cls-sally-12{fill:#595445;}.cls-sally-13{fill:#dd9c73;}.cls-sally-14{fill:#e7a595;}.cls-sally-15{fill:#070707;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-sally-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-1",
    d: "M192.59,154.62s-1.1,37.34,20.67,39.49-7.53,80.39-36,84.69S105,251,112.15,228.54c12.48-39,6.27-76.22,6.27-76.22Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-2",
    d: "M25.15,565.72s-1.51,21.37.22,38.62,279.21,7.48,279.21,7.48.88-31-1.71-46.54S25.15,565.72,25.15,565.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-sally-3",
    points: "108.63 565.72 257.93 565.72 225.71 215.81 118.8 247.29 108.63 565.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-4",
    d: "M78.22,177.88s-51.41,16.76-60.76,38.71-32.79,194.12-2.39,224.07L32,456s.63,23.87-2.54,33.76-4.35,76-4.35,76h92.06s54.61-181.33,47-253.41L132.46,253Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-sally-5",
    x: 92.06,
    y: 137.62,
    width: 130.04,
    height: 66.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-1",
    d: "M192.59,154.62s-1.1,37.34,20.67,39.49-7.53,80.39-36,84.69S105,251,112.15,228.54c12.48-39,6.27-76.22,6.27-76.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-sally-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-7",
    d: "M122.46,35.21s19.64,3,26.78-.49c0,0,28.85.55,47.93,20,6.58,6.72,16.05,37.44,16,47.64s-3.31,29.16-3.4,40.07c0,6.53-2,23.81-19.4,38.26-3,2.53-18,16.23-31,16.9-15.6.8-20.18-7.29-29.12-11.26-7.71-3.42-27.64-17.06-30.5-41.32-1.26-10.65-6-22.45-6.22-26.37C92.71,104.64,90.37,47.54,122.46,35.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-8",
    d: "M135.21,222.43l31.09,23.29s29.86-31.23,37.1-60.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-5",
    d: "M166.42,245.64s-2.6-1.9-3.53-.39c-1.42,2.29,2.38,4.9,4.76,5.88,0,0,3.92-4.64,2.51-6.38C168.56,242.77,166.42,245.64,166.42,245.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-9",
    d: "M108.43,150.93s-.08,15.74,13.73,38.31,34.22,84.39,48.57,98.74c0,0-9.61,1.85-17.86-12.5,0,0,24.31,40.47,24.67,55.35S175.63,341,175.63,341s-19.71-41.1-39.9-70.91c0,0,5.77,71.15-5.77,82.93,0,0,1.92-63.7-11.54-98.31,0,0-2.88,28.36,7.21,53.12,0,0,6.31,17.1,6.31,24.18s-24.55-54-25.65-68.62c0,0,3.73,43.48,17.85,63.07,0,0-18.34-15-21.29-31.6,0,0,5,39.21,15.76,54.12,0,0-17.43-8.91-22-27.27a123.77,123.77,0,0,0,1.51,26.49s-20-31.31-20-67.42,2.34-73.62,2.34-73.62-9.85,64.72-7,91.44c0,0-9.85-17.82-3.29-62.83S77.2,74,82.83,52.4s29.54-56.27,70.33-52S209.9,23.8,220.22,53.81s15.47,138.33,27.66,158c0,0-21.1,113-43.61,127.08,0,0,12.2-33.29,13.6-58.15s-16.41-68.46-4.69-106.91c0,0-10.71,20.4-4.54,66.65,0,0-9.94-32.89-8.22-51.39s6.85-45.92,6.16-62.36-15.76-90.46-15.76-90.46L112,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-1",
    d: "M122.46,19.53s19.64,3,26.78-.5c0,0,28.85.56,47.93,20,6.58,6.72,16.05,37.44,16,47.64s-3.31,29.15-3.4,40.07c0,6.53-2,23.81-19.4,38.26-3,2.53-8.48,6.06-11.57,8.45-6.54,5.05-11.09,8.12-19.42,8.45-15.61.61-20.18-7.29-29.12-11.26-7.71-3.42-27.64-17.06-30.5-41.32-1.26-10.65-6-22.45-6.22-26.37C92.71,89,90.37,31.86,122.46,19.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-10",
    d: "M128.32,136.8s-1.3-3.68,15.13-3.08,35.54,0,35.54,0-5.27,20.41-20.21,19.61S128.62,142.68,128.32,136.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-11",
    d: "M159.2,131.17c-3.26.9-4.27,1.69-11.36.45-9.48-1.65-22.55,3.83-22.55,3.83s6.8,21.48,29,21.15c22.61-.34,27.9-22.84,27.9-22.84C176.86,129.71,162.46,130.27,159.2,131.17Zm-4.61,20.7c-18.22-.11-24.64-14.73-24.64-14.73,5.4-1,11.38,2.14,24.08,1.46s18.89-4.5,24.18-3.26C178.21,135.34,170.57,152,154.59,151.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-4",
    d: "M228.29,310.91s16.33,225,26.26,254.78l48.32-.41S285.12,465,286.35,443.57s11-144.92,11-144.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-12",
    d: "M126.93,491s-82.44-4.13-95.45-14.31c.08,1.56.6-9.79.57-21.44C32,449.21,124,477.21,126.93,491Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-13",
    d: "M256.46,395.8s12.3-16.92,22.56-16.41,46.39,5.9,46.39,5.9-5.64,11.28-12.3,11.79c0,0,5.12,6.15.51,12.05,0,0,3.33,12.56-.26,17.17S264.66,440.91,256.46,395.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-9",
    d: "M289.76,377.44,265.47,468a8.31,8.31,0,0,0,7.34,3.5l26.2-91.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-14",
    d: "M419,109.79a49.67,49.67,0,0,0-41.72-7.73c-20.95,5.55-36.53,18.72-36.53,18.72s-33.39-20.61-58.3,9.94c-15.75,19.33-4.46,47.39-4.46,47.39s-32.32,2.42-42.63,24.93c-15.09,32.94-.95,59.81-.95,59.81s-14.73,17.6-13.94,38.27c1.49,38.7,23.38,55.37,41.43,54.6,0,0,25.59,46.12,68.65,31.21,0,0,75.26,37.78,95.87-44,0,0,62.93-30.22,38.57-94,0,0,29.21-28.07,14.34-59.55-15.57-32.93-39.38-27.62-39.38-27.62S443.33,131.5,419,109.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-12",
    d: "M61,324.15S70.41,347.77,77.53,356c4,4.67,11.27,21.94,14.51,28s27.6,7.49,37.53,13.75,23.54,6,23.54,6l-31.74,13.81L72.14,415S55.67,330.67,61,324.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-12",
    d: "M225.77,397.74s20.39,91.42.89,94C226.66,491.71,189.85,425.76,225.77,397.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-1",
    d: "M225.77,397.74S246,390,254.66,392.12c8,1.92,20.06,5.47,30.35.69a1.6,1.6,0,0,1,2.26,1.72c-.61,3.4-1.85,8.37-4,9.2,0,0,37.28-1.45,38.89,6.78s-19,10.17-31.79,10.17-16.1.49-13.34,2.51c1.93,1.41,10.89,3,19.76,1.43s19.08-6,21.17-5.07,2.42,10.16-3.22,15.33c0,0,2.42,11.29-5,14,0,0-.48,5.81-8.23,8.55s-13.39,8.39-18.07,6.78-16-6.14-22.27-6.94-39.85-3.55-39.85-3.55S213,408.85,225.77,397.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-4",
    d: "M225.77,397.74s-11.52,23.34-1.18,59.39,2.07,34.58,2.07,34.58S121.41,512.42,32,456c-17.16-10.83-30.56-58.86-13.56-92.16S61,324.15,61,324.15s6,47.11,15.23,54.2,10.28,20.9,10.28,20.9,26.92-6,39,1.42S191.11,402.25,225.77,397.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-14",
    d: "M292,166.3s-33.24-5.19-34.18,20.51S289.42,188.46,292,166.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-14",
    d: "M415.07,359s20,3.25,18.5-21.5C432.06,312.53,411.31,346.71,415.07,359Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-sally-14",
    d: "M461.4,229.85s22,6.27,11,35.69S449.63,244.75,461.4,229.85Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "eyes"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-sally-10 eyeball",
    cx: 124.82,
    cy: 87.65,
    r: 12.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-sally-15 pupil",
    cx: 124.82,
    cy: 87.65,
    r: 7.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-sally-10 eyeball",
    cx: 176.42,
    cy: 86.57,
    r: 12.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-sally-15 pupil",
    cx: 176.42,
    cy: 86.57,
    r: 7.89
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSally);
export default __webpack_public_path__ + "static/media/Sally.4659e7c507b1df55dd866ea0b0dd8cfc.svg";
export { ForwardRef as ReactComponent };